import React from 'react'
import SarasRadioBox from '../../input/radioBox/SarasRadioBox2'
import SarasTrans from '../../notifications/SarasTrans'
import * as fn from "../../../helper/uiFunctions";

const FormRadioButton = (props) => {
    const { formObject, action, rowKey, radioKey, headerKey, text, id, ...restProps } = props;

    const [cssClass, setCssClass] = React.useState('')

    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    const onClick = (e, value) => {
        // console.log("form input changed", e, action, value);
        if (action.InputType === 'switch')
            setClassNameforSwitch(value)
        if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, radioKey);

        //send the parameters reqired by the form
        //TODO kalpesh: Why radiokey is passed as parameter here
        if (action.actionId) formObject.onFormAction(action, radioKey);
    }

    const setClassNameforSwitch = (isChecked) => {
        let cssclassName = "";

        if (!isChecked && viewData.dataList && viewData.dataList.colCssClass){
            cssclassName = viewData.dataList.colCssClass;
        }
        else if (isChecked) {
            cssclassName = fn.compareNumber(isChecked, 1) ? "uiStateActive" : "";
        }
        else {
            cssclassName = viewData.val === radioKey ? "uiStateActive" : "";
        }
        // console.log("FormRadioButton cssclassName",cssclassName);
        if(cssClass !== cssclassName)
            setCssClass(cssclassName);
    }

    if (viewData && hide === "0") {
        let isChecked = viewData.val === radioKey ? "1" : "0";
        // console.log("FormRadioButton",radioKey , " = " , isChecked)

        if (action.InputType === 'switch') {
            setClassNameforSwitch(isChecked);

            return (
                <label htmlFor={id} className={`switchOnOffLabel ${cssClass}`}><SarasTrans value={viewData.dataList.valS || text} />
                    <SarasRadioBox id={id} className="switchOnOff" value={isChecked} onChange={onClick} {...restProps} />
                </label>
            )
        }
        else {
            return (
                <div className="uiRadio">
                    <SarasRadioBox value={isChecked} onChange={onClick} {...restProps} />
                    <label className="uiVal"><SarasTrans value={viewData.dataList.valS || text} /></label>
                </div>
            )
        }
    }

    return (null);
}

export default FormRadioButton